export default __webpack_public_path__ + "static/media/carousel1.cce1ab55.jpg";